window.axios = require('axios')
window._ = require('lodash')
window.StompJS = require('@stomp/stompjs')
window.SockJS = require('sockjs-client')
window.moment = require('moment')

// // 与Electron交互
// const { ipcRenderer } = require('electron')
// const http = require('http')
// const fs = require('fs')
// const os = require('os')
// const path = require('path')
// // const Store = require('electron-store')

// window.ipcRenderer = ipcRenderer
// window.http = http
// window.fs = fs
// window.os = os
// window.path = path
// // window.store = new Store()
